import { useEffect, useState } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useApi } from '../../lib/useApi'
import Collapsible from '../UI/Collapsible.jsx'

const FIELDS = [
  ['wake',       'time',   'Wake'],
  ['breathing',  'number', 'Breathing (min)'],
  ['meditation', 'number', 'Meditation (min)'],
  ['cardio',     'number', 'Cardio (min)'],
  ['training',   'text',   'Training'],
  ['abs',        'number', 'Abs (sets)'],
  ['weight',     'number', 'Weight (kg)'],
  ['bp',         'text',   'Blood pressure'],
  ['fokus',      'text',   'Fokus'],
  ['supps',      'text',   'Supps'],
  ['sauna',      'number', 'Sauna (min)'],
  ['hair',       'text',   'Hair'],
  ['koffein',    'number', 'Koffein (mg)'],
  ['energy',     'number', 'Energy 1-10'],
  ['bed',        'time',   'Bed'],
  ['diary',      'text',   'Diary note'],
]

export default function HeuteForm() {
  const api = useApi()
  const qc = useQueryClient()
  const { data: today } = useQuery({ queryKey: ['daily-today'], queryFn: () => api.get('/daily') })
  const [draft, setDraft] = useState({})

  useEffect(() => {
    setDraft(today?.values || {})
  }, [today?.date])

  async function save() {
    await api.put('/daily', { values: draft })
    qc.invalidateQueries({ queryKey: ['daily-today'] })
    qc.invalidateQueries({ queryKey: ['daily-range'] })
  }

  return (
    <Collapsible title="Heute-Form" defaultOpen={false}>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {FIELDS.map(([k, type, label]) => (
          <label key={k} className="flex flex-col gap-1">
            <span className="label-mini">{label}</span>
            <input
              type={type}
              value={draft[k] ?? ''}
              onChange={(e) => setDraft({ ...draft, [k]: type === 'number' ? Number(e.target.value) : e.target.value })}
              onBlur={save}
              className="bg-transparent border border-white/15 rounded-md px-2 py-1.5 text-sm num focus:border-[var(--accent)] outline-none"
            />
          </label>
        ))}
      </div>
    </Collapsible>
  )
}
